import dynamic from "next/dynamic";

import Modal from "@stadium/ui/src/components/ModalNew";
import {
  CloseButton,
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
  ModalFooter,
} from "@stadium/ui/src/components/ModalNew/utils";
import { PageLoader } from "@stadium/ui/src/components/loaders/loaders";
import Button from "@stadium/checkout/src/components/shared/buttons";
import OrderSummary from "./order-summary";
const ChromeAppWidget = dynamic(() => import("@stadium/ui/src/components/chrome-app-widget"));

import styles from "./main.module.scss";

const emptyObj = {};

const PlacedOrderSummary = ({
  children,
  headerTitle = "",
  bodyTitle = "",
  summaryTableTitle = "",
  orderData = emptyObj,
  orderDataLoading = false,
  closeModalHandler,
  showDownloadCta = true,
  footerClass = "",
  renderRightSection,
  showChromeAppWidget = false,
  checkoutFlowName = "",
}) => {
  const isRenderRightSection = typeof renderRightSection === "function";

  return (
    <Modal closeModal={closeModalHandler} className={styles.orderConfirmationModal}>
      <ModalDialog
        className={`${styles.orderConfirmationModalDialog} ${
          isRenderRightSection ? styles["qrCodeEnabled"] : ""
        } ${showChromeAppWidget ? styles["chromeExtEnabled"] : ""}`}
      >
        <ModalContent
          className={`${styles.primaryModalContent} ${styles.contentWithFooter} ${styles.orderSummaryModal}  `}
        >
          <ModalHeader className={styles.modalHeader}>
            <div className={styles.modalHeading}>{headerTitle}</div>
            <CloseButton onClick={closeModalHandler} className={styles.closeIcon} />
          </ModalHeader>

          <ModalBody className={styles.modalBody}>
            {orderDataLoading ? (
              <div className={styles.pageLoaderCenter}>
                <PageLoader />
              </div>
            ) : (
              <div className={styles.topContainer}>
                <div className={styles.subHeading}>{bodyTitle}</div>
                <div className={isRenderRightSection ? styles.contentWrapperContainer : ""}>
                  <div className={styles.modalLeftContent}>
                    <OrderSummary
                      summaryTableTitle={summaryTableTitle}
                      orderData={orderData}
                      showDownloadCta={showDownloadCta}
                      footerClass={footerClass}
                    />
                    {children}
                  </div>
                  {isRenderRightSection && (
                    <div className={styles.modalRightContent}>{renderRightSection()}</div>
                  )}
                  {showChromeAppWidget && <ChromeAppWidget flowName={checkoutFlowName} />}
                </div>
              </div>
            )}
          </ModalBody>

          <ModalFooter className={styles.modalFooter}>
            <Button
              styleType="primary"
              className={`${styles.footerButton}`}
              onClick={closeModalHandler}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </ModalDialog>
    </Modal>
  );
};

export default PlacedOrderSummary;
